"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsModule = void 0;
const router_1 = require("client/components/router");
const labels_view_1 = require("./modules/labels-view");
class LabelsModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("labels", /^\/labels?$/, labels_view_1.LabelsView);
    }
}
exports.LabelsModule = LabelsModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/labels.tsx
// module id = 3697
// module chunks = 0